export default "__VITE_ASSET__C$HztOat__"